import { FC } from "react";
import { AuthProvider } from "hooks";

export const AuthService: FC<any> = ({ children }) => (
  <AuthProvider>{children}</AuthProvider>
);
